import { useFeatureGoogleAnalytics } from '../../../../shared_app/hooks/useFeatureGoogleAnalytics';
var PARENT_REPORT_EVENT_CATEGORY = 'ParentReport';
var ParentReportEvents = {
    pageView: PARENT_REPORT_EVENT_CATEGORY + "_Open",
    downloadEnglishReportClick: PARENT_REPORT_EVENT_CATEGORY + "_DownloadReport_New_Eng",
    downloadSpanishReportClick: PARENT_REPORT_EVENT_CATEGORY + "_DownloadReport_New_Es",
    requestEnglishReportClick: PARENT_REPORT_EVENT_CATEGORY + "_RequestReport_New_Eng",
    requestSpanishReportClick: PARENT_REPORT_EVENT_CATEGORY + "_RequestReport_New_Es",
};
var useParentReportAnalytics = function () {
    return useFeatureGoogleAnalytics(PARENT_REPORT_EVENT_CATEGORY);
};
export { useParentReportAnalytics, ParentReportEvents };
